import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { NUMBER_ICONS, CIRCLE_ICONS, TILE_ICONS } from 'constants/icons';
import { CmsHeading } from 'components/CmsPage/modules/CmsHeading/CmsHeading';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';
import { NestDocumentLevel } from 'providers/DocumentLevel';
var ICON_POSITIONS = ['top', 'left', 'left-center'];

var ICON_SRC_BY_NAME = _objectSpread({}, NUMBER_ICONS, CIRCLE_ICONS, TILE_ICONS);

export var Tile = function Tile(_ref) {
  var description = _ref.description,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      title = _ref.title;
  var src = ICON_SRC_BY_NAME[icon];
  var tileClassName = classNames(_defineProperty({
    Tile: true
  }, "Tile--position-".concat(iconPosition), ICON_POSITIONS.includes(iconPosition)));
  return React.createElement(NestDocumentLevel, null, React.createElement("section", {
    className: tileClassName
  }, src && React.createElement(Isvg, {
    className: "Tile__icon",
    src: src
  }), React.createElement("div", {
    className: "Tile__content"
  }, React.createElement(CmsHeading, {
    size: "large",
    title: title
  }), React.createElement(CmsText, {
    content: description
  }))));
};
Tile.defaultProps = {
  iconPosition: 'top'
};
Tile.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.oneOf(Object.keys(ICON_SRC_BY_NAME)),
  iconPosition: PropTypes.oneOf(ICON_POSITIONS),
  title: PropTypes.string
};